import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MobileRoutingModule } from './mobile.routing.module';
import { SharedModule } from '../shared/shared.module';

// Components
import {
    DoctorCardModule, CompanyCardModule, MobileCalendarModule,
    InsuranceComponent
} from './components';

// Modals
import {
    MobileModalAttendanceCardModule, ModalMobileCalendarModule
} from './modals';

//Pages
import {
    CalendarPageModule, MobileSelectPaymentPageComponent,
    DoctorListPageModule, CompanyListPageModule, CardInfoPageModule, SelectAddressPageModule,
    SelectEventPageModule, SelectDoctorPageModule, ResumeCheckoutPageModule,
    ConfigurationPageModule, AttendanceHistoryModule,
    ScheduledSuccessfullyPageModule
} from './pages';

//Services
import { MobileSearchService } from './services'

@NgModule({
    declarations: [
        // Components
        InsuranceComponent,

        // Modals

        //Pages
        MobileSelectPaymentPageComponent,
    ],
    imports: [
        SharedModule,
        MobileRoutingModule,

        // Project components/pages modules
        DoctorListPageModule,
        CompanyListPageModule,
        DoctorCardModule,
        CompanyCardModule,
        CardInfoPageModule,
        SelectAddressPageModule,
        SelectEventPageModule,
        SelectDoctorPageModule,
        MobileCalendarModule,
        CalendarPageModule,
        ResumeCheckoutPageModule,
        ScheduledSuccessfullyPageModule,
        ConfigurationPageModule,
        AttendanceHistoryModule,
        MobileModalAttendanceCardModule,
        ModalMobileCalendarModule,
    ],
    providers: [
        MobileSearchService
    ],
    bootstrap: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MobileModule { }
